<template>
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-project @node-click="nodeClick"></erp-project>
  </div>
  <div class="d-flex-right" v-if="jname && id">
    <div>
      <el-button size="mini" type="primary text2" @click="discounts()">添加费项设置</el-button>
      <el-input size="mini" class="search" placeholder="请输入搜索收费项名称" v-model="search" clearable></el-input>
      <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
    </div>
    <div>位置：{{company_name}}-{{jname}}-{{name}}</div>
    <v-divider></v-divider>
    <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">ID</th>
          <th class="text-left">收费项名称</th>
          <th class="text-left">项目</th>
          <th class="text-left">状态</th>
          <th class="text-left">当前操作人</th>
          <th class="text-left">添加时间</th>
          <th class="text-left">操作</th>
        </tr>
        </thead>
        <tbody
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)">
        <tr class="text1" v-for="it in data" :key="it.id">
          <td >{{it.id}}</td>
          <td >{{it.charge_name}}</td>
          <td >{{it.pindex_name}}</td>
          <td >{{it.offons}}</td>
          <td >{{it.founder}}</td>
          <td >{{it.date}}</td>
          <td class="cdj_td">
            <div style="color: #0055ff;margin-left: 5px;cursor: pointer;" @click="edit(it.id)">编辑修改</div>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="data">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
    <Modal
      v-model="modal1"
      ok-text="确定"
      width="600px"
      @on-ok="addDis"
      title="编辑费项(费用_金额是当前缴费金额)">
      <div style="height: 700px;overflow: auto;">
        <el-form label-width="10px">
          <h2 style="margin-left: 10px;margin-bottom: 10px;">折扣设置</h2>
          <span class="cdj_spans">项目收费项</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-select v-model="datas.charge_id" filterable placeholder="请选择收费项" class="cdj_width">
              <el-option
                v-for="item in charge"
                :key="item.id"
                :label="item.names"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <span class="cdj_spans">空置房</span><span class="cdj_margin">（{{text}}）</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-input class="cdj_width" v-model="datas.discount1"></el-input>
          </el-form-item>
          <span class="cdj_spans">未领房</span><span class="cdj_margin">（{{text}}）</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-input class="cdj_width" v-model="datas.discount2"></el-input>
          </el-form-item>
          <span class="cdj_spans">空关房</span><span class="cdj_margin">（{{text}}）</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-input class="cdj_width" v-model="datas.discount3"></el-input>
          </el-form-item>
          <span class="cdj_spans">装修</span><span class="cdj_margin">（{{text}}）</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-input class="cdj_width" v-model="datas.discount4"></el-input>
          </el-form-item>
          <!-- <span class="cdj_spans">装修已审批未入住</span><span class="cdj_margin">（{{text}}）</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-input class="cdj_width" v-model="datas.discount4"></el-input>
          </el-form-item>
          <span class="cdj_spans">正在装修未入住</span><span class="cdj_margin">（{{text}}）</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-input class="cdj_width" v-model="datas.discount5"></el-input>
          </el-form-item>
          <span class="cdj_spans">已装修未入住</span><span class="cdj_margin">（{{text}}）</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-input class="cdj_width" v-model="datas.discount6"></el-input>
          </el-form-item> -->
          <span class="cdj_spans">已入住</span><span class="cdj_margin">（{{text}}）</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-input class="cdj_width" v-model="datas.discount7"></el-input>
          </el-form-item>
          <span class="cdj_spans">已出租</span><span class="cdj_margin">（{{text}}）</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-input class="cdj_width" v-model="datas.discount8"></el-input>
          </el-form-item>
          <span class="cdj_spans">是否开启</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-radio v-model="datas.offon" label="2">关闭</el-radio>
            <el-radio v-model="datas.offon" label="1">开启</el-radio>
          </el-form-item>
          <span class="cdj_spans">折扣生效日期</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-date-picker class="cdj_width" type="date" v-model="datas.date1" placeholder="选择日期" ></el-date-picker>
          </el-form-item>
          <span class="cdj_spans">折扣失效日期</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-date-picker class="cdj_width" type="date" v-model="datas.date2" placeholder="选择日期" ></el-date-picker>
          </el-form-item>
          <span class="cdj_spans">备注</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-input type="textarea" class="cdj_width" :rows="3" placeholder="请输入内容" v-model="datas.textarea"></el-input>
          </el-form-item>
          <!-- <span class="cdj_spans">保存类型</span>
           <el-form-item label="" class="cdj_margin_top">
             <el-radio v-model="datas.type" label="1" @change="datastype(1)" >折扣金额</el-radio>
             <el-radio v-model="datas.type" label="2" @change="datastype(2)">虚增应收</el-radio>
           </el-form-item>
           <span class="cdj_spans">不产生虚增应收的对应房态</span>
           <el-form-item label="" class="cdj_margin_top">
             <el-checkbox v-model="datas.checked1" :disabled='disabled'>已装修</el-checkbox>
             <el-checkbox v-model="datas.checked2" :disabled='disabled'>已入住</el-checkbox>
             <el-checkbox v-model="datas.checked3" :disabled='disabled'>已出租</el-checkbox>
             <el-checkbox v-model="datas.checked4" :disabled='disabled'>未领房</el-checkbox>
             <el-checkbox v-model="datas.checked5" :disabled='disabled'>空关房</el-checkbox>
           </el-form-item>
           <span class="cdj_spans">虚增应收的房态变化类型</span>
           <el-form-item label="" class="cdj_margin_top">
             <el-radio v-model="datas.fangtaiType" label="1" :disabled='disabled'>当月任何一天房态改变，当月不享受折扣</el-radio>
             <el-radio v-model="datas.fangtaiType" label="2" :disabled='disabled'>收费周期内任何一天房态改变，当前收费周期不享受折扣</el-radio>
             <el-radio v-model="datas.fangtaiType" label="3" :disabled='disabled'>当月任何一天房态改变，第二天不享受折扣</el-radio>
             <el-radio v-model="datas.fangtaiType" label="4" :disabled='disabled'>当月任何一天房态改变，当天开始不享受折扣</el-radio>
           </el-form-item> -->

          <h2 style="margin-left: 10px;margin-bottom: 10px;">违约金设置</h2>
          <span class="cdj_spans">违约金</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-radio v-model="datas.delay_off_no" label="1" @change="delaytype(1)">关闭</el-radio>
            <el-radio v-model="datas.delay_off_no" label="2" @change="delaytype(2)" >开启</el-radio>
          </el-form-item>
          <span class="cdj_spans">违约金比例（单位 %）</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-input class="cdj_width" v-model="datas.delay_unit" :disabled='disableds'></el-input>
          </el-form-item>
          <span class="cdj_spans">减免选择</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-radio v-model="datas.delay_type" label="1" @change="annul(1)" :disabled='disableds'>按天减免</el-radio>
            <el-radio v-model="datas.delay_type" label="2" @change="annul(2)" :disabled='disableds'>按月减免</el-radio>
          </el-form-item>
          <span class="cdj_spans">{{texts}}</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-input class="cdj_width" v-model="datas.delay_day_sun" :disabled='disableds'></el-input>
          </el-form-item>
          <span class="cdj_spans">违约金计费开始时间</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-radio v-model="datas.delay_start" label="1" :disabled='disableds'>应收日期</el-radio>
            <el-radio v-model="datas.delay_start" label="2" :disabled='disableds'>计费开始时间</el-radio>
            <el-radio v-model="datas.delay_start" label="3" :disabled='disableds'>计费结束时间</el-radio>
          </el-form-item>
          <span class="cdj_spans">违约金生效日期</span>
          <el-form-item label="" class="cdj_margin_top">
            <el-date-picker class="cdj_width" type="date" v-model="datas.delay_take_date" placeholder="选择日期" :disabled='disableds'></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </Modal>
  </div>
</div>
</template>
<script>
import ErpProject from "../Common/erp-project";
export default {
  name: 'pindexDiscounts',
  components: {ErpProject},
  data () {
    return {
      texts:'减免天数',
      disabled:true,
      disableds:true,
      company_name:'',
      id:'',
      jname:'',
      name:'',
      loading:'',
      search:'',
      total:0,
      page:12,
      anxiu:'保存',
      modal1: false,
      text:'费用_金额*折扣（如打7折，把1.00设置成0.7）',
      charge:[],
      datas:{
        charge_id:'',
        discount1:'1.00',
        discount2:'1.00',
        discount3:'1.00',
        discount4:'1.00',
        discount5:'1.00',
        discount6:'1.00',
        discount7:'1.00',
        discount8:'1.00',
        type:'1',
        checked1:'',
        checked2:'',
        checked3:'',
        checked4:'',
        checked5:'',
        date1:'',
        date2:'',
        offon:'1',
        textarea:'',
        fangtaiType:'1',
        delay_off_no:'1',
        delay_unit:'0.00',
        delay_type:'1',
        delay_day_sun:"0",
        delay_start:"1",
        delay_take:""
      },
      data:[],
      datasnull:[]
    }
  },
  //界面没出来前加载
  created() {

  },
  // 加载数据
  mounted(){
    this.datasnull = this.datas;
    var login = window.localStorage.getItem('login');
    var token = window.localStorage.getItem('token');
    this.id = this.$route.query.id;
    this.company_name = this.$route.query.company_name;
    this.jname = this.$route.query.jname;
    this.name = this.$route.query.name;
    // ERP.showLoading()
    // this.$Loading.start();
    // this.$myhttp.get('admin/discounts?id=1&aid='+this.id+"&search="+this.search,{
    //   'Content-Type': 'application/json'
    //   }).then(backdata=>{
    //     let data = backdata.data;
    //     this.data = data.data;
    //     this.total = data.count;
    //     this.page = data.oen;
    //     this.$Loading.finish();
    //   ERP.hideLoading()
    //   });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    annul(text){
      if(text == 1){
        this.texts = '减免天数';
      }else{
        this.texts = '减免月数';
      }
    },
    //违约金开启关闭
    delaytype(type){
      if(type == 1){
        this.disableds = true;
      }else{
        this.disableds = false;
      }
    },
    //折扣类型
    datastype(type){
      if(type == 1){
        this.disabled = true;
      }else{
        this.disabled = false;
      }
    },
    // 添加折扣
    discounts(){
      //查询收费项
      this.$myhttp.get('admin/getCharge?pid='+this.id,{
        'Content-Type': 'application/json'
      }).then(backdata=>{
            this.charge = backdata.data.data;
      });
      if(this.datas.id){
        this.datas={
          charge_id:'',
          discount1:'1.00',
          discount2:'1.00',
          discount3:'1.00',
          discount4:'1.00',
          discount5:'1.00',
          discount6:'1.00',
          discount7:'1.00',
          discount8:'1.00',
          type:'1',
          checked1:'',
          checked2:'',
          checked3:'',
          checked4:'',
          checked5:'',
          date1:'',
          date2:'',
          offon:'1',
          textarea:'',
          fangtaiType:'1',
          delay_off_no:'1',
          delay_unit:'0.00',
          delay_type:'1',
          delay_day_sun:"0",
          delay_start:"1",
          delay_take:""
        };
      }
      this.modal1 = true;
    },
    //保存折扣
    addDis(){
      let data = this.datas;
      data['pindex_id']=this.id;
      data['pindex_name']=this.name;
      this.$myhttp.post('admin/postDiscunts',data,{
      'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
          let data = backdata.data;
          if(data.code == 204){
            this.$Message.error(data.message);
          }
          if(data.code == 200){
            this.searchs();
            this.$Message.success('操作成功');
          }
      });
    },
    // 搜索
    searchs(){
      ERP.showLoading()
      this.$Loading.start();
      this.$myhttp.get('admin/discounts?id=1&aid='+this.id+"&search="+this.search,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          let data = backdata.data;
          this.data = data.data;
          this.total = data.count;
          this.page = data.oen;
          this.$Loading.finish();
        ERP.hideLoading()
        });
    },
    //分页
    change(oen){
      ERP.showLoading()
      this.$Loading.start();
      this.$myhttp.get('admin/discounts?id='+oen+'&aid='+this.id+"&search="+this.search,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          let data = backdata.data;
          this.data = data.data;
          this.total = data.count;
          this.page = data.oen;
          this.$Loading.finish();
        ERP.hideLoading()
        });
    },
    //点击编辑
    edit(id){
      //查询收费项
      this.$myhttp.get('admin/getCharge?pid='+this.id,{
        'Content-Type': 'application/json'
      }).then(backdata=>{
            this.charge = backdata.data.data;
      });
      this.$myhttp.get('admin/getDiscountsEdit?id='+id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.modal1 = true;
          this.datas = backdata.data.data;
          if(this.datas.type == 1){
            this.disabled = true;
          }else{
            this.disabled = false;
          }
          if(this.datas.delay_off_no == 1){
            this.disableds = true;
          }else{
            this.disableds = false;
          }
        });
    },
    nodeClick(e){
      //console.log(e)
      this.id=e.id;
      this.jname=e.name;
      this.change(1)
    }

  },
  watch: {
    '$route' (to, from) { //监听路由是否变化
      //加载项目
      if(to.path == "/pindex/Allocations"){
        this.id = this.$route.query.id;
        this.dades.pindex_id = this.id;
        this.company_name = this.$route.query.company_name;
        this.jname = this.$route.query.jname;
        this.name = this.$route.query.name;
      }
    }

  },

}
</script>
<style scoped>
  .cdj_margin_top{
    margin-top: 3px;
  }
  .cdj_spans{
    font-size: 15px;
    margin-left: 10px;
  }
.cdj_margin{
  color:red;
}
.cdj_width{
  width: 500px;
}
.ti{
  margin: 1%;
  width: 98%;
}
.kuan{
  width: 300px;
}
.text1{
  text-align: center;
}
.text{
    margin-left: 13%;
    color: rgb(214, 22, 86);
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhujie{
  margin-left: 12.7%;
  color: brown;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.el-button{
    color: rgb(252, 247, 247);
}
.item{
  margin-top: 1%;
}
.ys{
  color: brown;
}
  .d-flex {
    display: flex;
  }

  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
  }

  .d-flex-right {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/discounts.vue